// extracted by mini-css-extract-plugin
export default {"container":"Alert_container__8kUA8","title":"Alert_title__y8eHe","text":"Alert_text__v0Eek","button":"Alert_button__uMFUW"};